import { FC } from 'react'

import styles from './SlideProductCardSkeleton.module.scss'

import Skeleton from 'components/atom/Skeleton'

const SlideProductCardSkeleton: FC = () => (
  <div className={styles.wrapper}>
    <Skeleton className={styles.wrapper_image} width='100%' height='380px' />
    <Skeleton className={styles.wrapper_title} width='70%' height='23px' />
    <Skeleton className={styles.wrapper_subtitle} width='40%' height='23px' />
  </div>
)

export default SlideProductCardSkeleton
